module.exports = __webpack_public_path__ + "img/5-3.b4b63d03.png";